/* @flow */

import React from 'react';
import { TableHead, TableCell, TableRow, Checkbox, Tooltip, IconButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import SortableList from './SortableList';
import customStyles from './ListComponent.module.scss';
import SortableItem from './SortableItem';

export type Props = {
    classes: any,
    expandRow: Function,
    enableColumnRearrange: boolean,
    iconStyle: any,
    isExpanded: boolean,
    numSelected: number,
    onSelectAllClick: Function,
    onRequestSort: Function,
    rearrangeColumns: Function,
    order: any,
    orderBy: any,
    rowCount: number,
    tableData: {
        listData: Array<{
            id: number,
            keyName: string,
            isLink: boolean,
            path: string,
        }>,
        listHeaders: Array<{
            id: number,
            disableSort: boolean,
            keyName: string,
            isLink: boolean,
            path: string,
            show: boolean,
            displayUnit: string,
        }>,
        ischeckBox: boolean,
        isDeletable:boolean,
        isEditable: boolean,
        isAddButton: boolean,
        isGroup: boolean,
        totalRecords: number,
    },
    resizableHeader: boolean,
    rowActions: Object,
    userPermission: string,
};
export type State = {
    items: any,
    activeObject: any,
    isResizing: boolean,
};

const styles = () => ({
    checkbox: {
        color: '#4a4a4a',
        opacity: '0.54',
    },
    checked: {
        color: '#007aff !important',
        opacity: 1,
    },
    icon: {
        fill: '#fff !Important',
        backgroundColor: '#4a4a4a',
        borderRadius: '50%',
        opacity: '0.54',
        height: '18px !Important',
        width: '18px !Important',
    },
    dragHelper: {
        boxShadow: 'rgba(224, 224, 224, 1) 0px 4px 3px -2px',
        borderBottom: 'none',
        '&> div': {
            background: '#ccc',
            borderRadius: '3%',
            margin: '10px 0 0 0',
            paddingLeft: '10px',
        },
    },
    overrideClass: {
        '& *': {
            cursor: 'grabbing !important',
        },
    },
    root: {
        '&:hover': {
            color: '#000',
        },
    },
});

class TableHeaderComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            items: this.getFormattedItems(props.tableData.listHeaders),
            activeObject: null,
            isResizing: false,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        this.rows = this.getFormattedItems(nextProps.tableData.listHeaders);
        this.setState({
            items: this.rows,
        });
    }

    rows: any = [];

    getFormattedItems = listHeaders => listHeaders.map(item => ({
        ...item,
        id: Object.keys(item)[0],
    }));

    createSortHandler = (property: any) => (event: any) => {
        this.props.onRequestSort(event, property);
    };
    getIcon = (id, isExpanded) => {
        let icon =
            (
                <Tooltip title="Expand">
                    <IconButton
                        aria-label="Expand"
                        style={{ ...this.props.iconStyle, marginRight: 8 }}
                        onClick={() => this.props.expandRow(id, true)}
                        size="large"
                    >
                        <ChevronRight
                            className={this.props.classes.icon}
                        />
                    </IconButton>
                </Tooltip>
            );
        if (isExpanded) {
            icon =
            (
                <Tooltip title="Collapse" >
                    <IconButton
                        aria-label="Collapse"
                        style={{ ...this.props.iconStyle, marginRight: 8 }}
                        onClick={() => this.props.expandRow(id, false)}
                        size="large"
                    >
                        <ExpandMore
                            className={this.props.classes.icon}
                        />
                    </IconButton>
                </Tooltip>
            );
        }
        return icon;
    }

    render() {
        const {
            classes,
            numSelected,
            onSelectAllClick,
            rowCount,
            userPermission,
            rowActions,
        } = this.props;
        const {
            isGroup, ischeckBox, isEditable, isAddButton, isDeletable,
        } = this.props.tableData;
        const { items, activeObject, isResizing } = this.state;

        return (
            <TableHead id="table-header">
                <TableRow id="table-header-row">
                    {
                        ischeckBox && userPermission === 'Modify' &&
                        <TableCell padding="checkbox" className={customStyles.checkboxWrapper}>
                            {!isGroup &&
                                <Checkbox
                                    indeterminate={numSelected > 0 && numSelected < rowCount}
                                    checked={(numSelected === rowCount && numSelected > 0)}
                                    onChange={onSelectAllClick}
                                    color="primary"
                                    classes={{
                                        checked: classes.checked,
                                        root: numSelected > 0 && numSelected < rowCount
                                            ? classes.checked : classes.checkbox,
                                    }}
                                />
                            }
                        </TableCell>
                    }
                    {
                        userPermission === 'Modify' && (isEditable || isAddButton || isDeletable) &&
                        <TableCell padding="checkbox">
                            <span style={{ paddingLeft: 10 }}>
                                Actions
                            </span>
                        </TableCell>
                    }
                    <SortableList
                        items={items}
                        onChange={(itemValues) => this.setState({ items: itemValues })}
                        rearrangeColumns={this.props.rearrangeColumns}
                        setActiveObject={(value) => this.setState({ activeObject: value })}
                        activeObject={activeObject}
                        isResizing={isResizing}
                        rowActions={rowActions}
                        userPermission={userPermission}
                        renderItem={(item, index, isSortableOverlay) => (
                            <SortableItem
                                setResizable={(value) => this.setState({ isResizing: value })}
                                isResizing={isResizing}
                                setActiveObject={(value) => this.setState({ activeObject: value })}
                                activeObject={activeObject}
                                id={item.id}
                                key={item.id}
                                isSortableOverlay={isSortableOverlay}
                                rearrangeColumns={this.props.rearrangeColumns}
                                onRequestSort={this.props.onRequestSort}
                                items={items}
                                index={index}
                                item={item}
                                enableColumnRearrange={this.props.enableColumnRearrange}
                                orderBy={this.props.orderBy}
                                order={this.props.order}
                                resizableHeader={this.props.resizableHeader}
                                customStyles={customStyles}
                                isGroup={this.props.tableData.isGroup}
                                isExpanded={this.props.isExpanded}
                                getIcon={this.getIcon}
                                createSortHandler={this.createSortHandler}
                                classes={this.props.classes}
                            />
                        )}
                    />
                </TableRow>
            </TableHead>
        );
    }
}

export default withStyles(styles)(TableHeaderComponent);
